import type { ReactNode } from 'react';

export const symbol_elderly: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M538-754q-30 0-51.5-21.5T465-827q0-30 21.5-51.5T538-900q30 0 51.5 21.5T611-827q0 30-21.5 51.5T538-754Zm146.5 344.5Q680-414 680-420v-33q-42-11-87.5-42T521-568q-12 34-18.5 75t-4.5 73l91 129q3 4 4.5 8.5t1.5 9.5v203q0 13-8.5 21.5T565-40q-13 0-21.5-8.5T535-70v-189l-85-95-9 145q0 3-6 16L338-64q-8 10-20 12t-22-6q-10-8-12-20t6-22l86-115-8-191q-2-52 5.5-109.5T397-617l-97 56v81q0 13-8.5 21.5T270-450q-13 0-21.5-8.5T240-480v-99q0-8 4-15t11-11l152-87q17-10 32.5-15t29.5-5q27 0 48.5 21t41.5 66q20 46 59 75.5t94 46.5q7-4 13.5-5.5T739-510q23 0 42 18.5t19 41.5v395q0 6-4.5 10.5T785-40q-6 0-10.5-4.5T770-55v-395q0-12-9-21t-21-9q-12 0-21 9t-9 21v30q0 6-4.5 10.5T695-405q-6 0-10.5-4.5Z"
		/>
	</svg>
);
